export const YOUTUBE_EMBED_URL_PATTERN =
  /^https?:\/\/(www\.)?youtube\.com\/embed\/[A-Za-z0-9_-]{11}(?:\?.*)?$/;

export const extractYouTubeVideoId = (url) => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  const trimmedUrl = url.trim();

  // Direct embed url.
  {
    const match = trimmedUrl.match(
      /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([A-Za-z0-9_-]{11})(?:\?.*)?$/
    );
    if (match?.[1]) {
      return match[1];
    }
  }

  const patterns = [
    // https://www.youtube.com/watch?v=VIDEO_ID&other_params
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([A-Za-z0-9_-]{11})/,
    // https://m.youtube.com/watch?v=VIDEO_ID
    /(?:https?:\/\/)?m\.youtube\.com\/watch\?.*v=([A-Za-z0-9_-]{11})/,
    // https://youtube.com/watch?v=VIDEO_ID (без www)
    /(?:https?:\/\/)?youtube\.com\/watch\?.*v=([A-Za-z0-9_-]{11})/,
    // https://youtu.be/VIDEO_ID
    /(?:https?:\/\/)?youtu\.be\/([A-Za-z0-9_-]{11})/,
    // https://www.youtube.com/shorts/VIDEO_ID
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})(?:[/?#].*)?$/,
    // https://youtube.com/shorts/VIDEO_ID (без www)
    /(?:https?:\/\/)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})(?:[/?#].*)?$/,
  ];

  for (const pattern of patterns) {
    const match = trimmedUrl.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  return null;
};

export const convertToYouTubeEmbed = (url) => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const trimmedUrl = url.trim();

  if (YOUTUBE_EMBED_URL_PATTERN.test(trimmedUrl)) {
    return trimmedUrl;
  }

  const videoId = extractYouTubeVideoId(trimmedUrl);
  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}`;
  }

  return trimmedUrl;
};

export const getYouTubeThumbnailUrl = (url) => {
  const videoId = extractYouTubeVideoId(url);
  if (!videoId) {
    return null;
  }
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};

export const toYouTubeWatchUrl = (url) => {
  const videoId = extractYouTubeVideoId(url);
  if (!videoId) {
    return null;
  }
  return `https://www.youtube.com/watch?v=${videoId}`;
};

const youtubeTitleCache = new Map();

export const fetchYouTubeTitle = async (url, { baseUrl } = {}) => {
  const videoId = extractYouTubeVideoId(url);
  if (!videoId) {
    return null;
  }

  if (youtubeTitleCache.has(videoId)) {
    return youtubeTitleCache.get(videoId);
  }

  const watchUrl = toYouTubeWatchUrl(url);
  if (!watchUrl) {
    return null;
  }

  const origin = (baseUrl || '').replace(/\/$/, '');
  const endpoint = `${origin}/youtube/oembed?url=${encodeURIComponent(watchUrl)}`;

  try {
    const response = await fetch(endpoint);
    if (!response.ok) {
      youtubeTitleCache.set(videoId, null);
      return null;
    }
    const data = await response.json();
    const title = (data && data.title ? String(data.title) : '').trim() || null;
    youtubeTitleCache.set(videoId, title);
    return title;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to fetch YouTube title', error);
    youtubeTitleCache.set(videoId, null);
    return null;
  }
};

